import React from "react";
import { Box } from "@mui/material";
import RenderDate from "../../../Common/Date/RenderDate";

function DevelopmentNeedStatusDetails({
    status,
    dateReview,
    dateCompletion,
    dateEnd,
}) {
    const words = status.split("_");
    words[0] = words[0][0].toUpperCase() + words[0].substring(1);
    const title = words.join(" ");

    return (
        <Box className="flex-container">
            <dl className="row-data">
                <dt>Review</dt>
                <dd>
                    <RenderDate date={dateReview ?? ""} />
                </dd>
            </dl>
            <dl className="row-data">
                <dt>Completion</dt>
                <dd>
                    <RenderDate date={dateCompletion ?? ""} />
                </dd>
            </dl>
            <dl className="row-data">
                <dt>End</dt>
                <dd>
                    <RenderDate date={dateEnd ?? ""} />
                </dd>
            </dl>
            <dl className="row-data">
                <dt>Status</dt>
                <dd>{title}</dd>
            </dl>
        </Box>
    );
}

export default DevelopmentNeedStatusDetails;
